import { ReactNode } from "react";

import messages from "../messages/ja.json";
import { FeVersion } from "./fe-version";
import { Icon } from "./icon";

import "../styles/auth-flow.css";
import "../styles/face-registration.css";

interface Props {
  username?: string;
  // Header title + description. Defaults to the face-registration copy.
  title?: string;
  description?: string;
  // Orange "first-time only" strip — shown on registration, hidden on verify-mfa.
  showBanner?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

// Full-page shell shared by the face-registration and verify-mfa flows
// (Figma: [banner] + user info + header + full-bleed camera + footer).
export function FaceRegistrationShell({
  username,
  title = messages.face.registerTitle,
  description = messages.face.registerDescription,
  showBanner = false,
  children,
  footer,
}: Props) {
  return (
    <main className="face-registration-shell">
      {showBanner ? (
        <div className="auth-info-banner" role="status">
          <Icon name="info" size={18} className="auth-info-banner-icon" />
          <span>{messages.changePassword.firstTimeBanner}</span>
        </div>
      ) : null}

      <header className="face-registration-header prev-header">
        {username ? (
          <div className="face-registration-user">
            <span className="face-registration-user-label">{messages.auth.userLabel}</span>
            {/* title: the value is ellipsised rather than wrapped, so keep the full
                address reachable on hover. */}
            <span className="face-registration-user-value" title={username}>
              {username}
            </span>
          </div>
        ) : null}
        <FeVersion className="fe-version-corner" />
        <h1 className="face-registration-title">{title}</h1>
        <p className="face-registration-description">{description}</p>
      </header>

      <div className="face-registration-body">{children}</div>

      {footer ? <footer className="face-registration-footer">{footer}</footer> : null}
    </main>
  );
}
